import moment from "moment";

const YEAR_MONTH_PATTERN = /^\d{4}-(0[1-9]|1[0-2])$/;

const normalizeYearMonth = (value) => {
  const raw = String(value || "").trim();
  return YEAR_MONTH_PATTERN.test(raw) ? raw : null;
};

/** Leave start month is after accrual-until month (notice period). */
export const isLeaveStartAfterAccrualStop = (accrualStopYearMonth, leaveStartDate) => {
  const stopYm = normalizeYearMonth(accrualStopYearMonth);
  if (!stopYm || !leaveStartDate) return false;
  const startYm = moment(leaveStartDate).format("YYYY-MM");
  return startYm > stopYm;
};

/**
 * Paid leaves applicable to a new request.
 * During notice period: no new accrual, but remaining balance can still be used.
 */
export const resolveAvailablePaidLeavesForRequest = (leaveBalance, startDate) => {
  if (!leaveBalance) return 0;

  return Math.max(
    0,
    Number(
      leaveBalance.availableLeavesForNewLeave != null && !startDate
        ? leaveBalance.availableLeavesForNewLeave
        : leaveBalance.availableLeaves ?? 0
    )
  );
};
